import React from 'react';
import { Col, Container, Row, Button, Table } from 'react-bootstrap';

import './styles/invitecashback.css';

export default function inviteCashBack() {
  return (
    <>
      <div className="invitecashback m-3">
        <Container>
            <Row>
            <div className="invite_cash_head d-flex justify-content-start mb-4" >
                    <h2>Cash Back</h2>
                </div>
                <Col>
                  <div className="invite_cash_col">
                    <div className="invite_cash_btns d-flex gap-4">
                        <div className="invite_cash_btn">
                            <Button className='active'>Overview</Button>
                        </div>
                        <div className="invite_cash_btn">
                            <Button>Spot</Button>
                        </div>
                        <div className="invite_cash_btn">
                            <Button>Futures</Button>
                        </div>
                    </div>
                    <Table responsive className='mt-3 text-start'>
                        <thead className='invite_cash_thead'>
                            <tr className=''>
                                <th className='border-bottom-0'>Commission Income</th>
                                <th className='border-bottom-0'>Type</th>
                            </tr>
                        </thead>
                        <tbody>
                           <tr className=''>
                            <td>O USDT</td>
                            <td>Spot</td>
                           </tr>
                           <tr>
                            <td>O USDT</td>
                            <td>Futures</td>
                           </tr>
                        </tbody>
                    </Table>

                    <div>
                        <div className="invite_cash_content d-flex justify-content-between align-items-center">
                          <div className="invite_cash_content_para">
                            <p>Displays all data from the past day. To view detailed transaction history, click "Export".</p>
                          </div>
                          <div className="invite_cash_content_link">
                            <a target='blank'>Export</a>
                          </div>
                        </div>
                    </div>
                  </div>
                </Col>
            </Row>
        </Container>
      </div>
    </>
  )
}
